/* Lunar Haus — dark content-page FX: header starfield + parallax + scroll/load reveal.
   Runs only on body.lh-dark. Progressive enhancement (no JS => content just shows). */
(function () {
  if (!document.body.classList.contains('lh-dark')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) starfields in the dark banner headers */
  var heroes = [].slice.call(document.querySelectorAll('.lh-library__head, .lhz-hero'));
  var layers = [];
  heroes.forEach(function (h) {
    var layer = document.createElement('div');
    layer.className = 'lh-stars';
    h.insertBefore(layer, h.firstChild);
    layers.push(layer);
    for (var i = 0; i < 14; i++) {
      var s = document.createElement('span');
      s.className = 'lh-star';
      var outline = Math.random() < 0.5;
      s.style.left = (Math.random() * 100).toFixed(2) + '%';
      s.style.top = (Math.random() * 100).toFixed(2) + '%';
      s.style.setProperty('--o1', (0.14 + Math.random() * 0.12).toFixed(2));
      s.style.setProperty('--o2', (0.4 + Math.random() * 0.3).toFixed(2));
      s.style.setProperty('--d', (9 + Math.random() * 8).toFixed(1) + 's');
      s.style.setProperty('--dl', (-Math.random() * 9).toFixed(1) + 's');
      s.style.setProperty('--dx', (Math.random() * 8 - 4).toFixed(1) + 'px');
      s.style.setProperty('--dy', (-(6 + Math.random() * 8)).toFixed(1) + 'px');
      if (outline) {
        s.textContent = '✧';
        s.style.fontSize = (7 + Math.random() * 7).toFixed(1) + 'px';
      } else {
        s.classList.add('dot');
        var d = (1.4 + Math.random() * 2).toFixed(1);
        s.style.width = d + 'px';
        s.style.height = d + 'px';
      }
      layer.appendChild(s);
    }
  });

  /* 2) scroll / load reveal on content elements */
  if ('IntersectionObserver' in window && !reduce) {
    var sel = '.lh-article__title,.lh-article__meta,.lh-article__feature,' +
      '.lh-article__body h2,.lh-article__body h3,.lh-article__body img,.lh-article__body blockquote,' +
      '.lh-page__title,.lh-library__intro,.lh-card,' +
      '.lhz-h1,.lhz-h2,.lhz-lead,.lhz-card,.lhz-cta,.lh-author,.lh-faq,.lh-related,.lhp-feed';
    /* Only animate what starts BELOW the fold. Anything already on screen when this
       (deferred) script runs has been painted, so hiding it and fading it back in just
       blanks the page for a beat. Leave it alone. */
    var vh0 = window.innerHeight || document.documentElement.clientHeight;
    var els = [].slice.call(document.querySelectorAll(sel)).filter(function (e) {
      var r = e.getBoundingClientRect();
      return !(r.top < vh0 && r.bottom > 0);
    });
    els.forEach(function (e) { e.classList.add('lh-rv'); });
    function show(el, idx) {
      el.style.transitionDelay = (Math.min(idx || 0, 3) * 60) + 'ms';
      el.classList.add('in');
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target,
          sib = el.parentElement ? [].slice.call(el.parentElement.children).filter(function (c) { return c.classList.contains('lh-rv'); }) : [el];
        var idx = sib.indexOf(el); if (idx < 0) idx = 0;
        show(el, idx);
        io.unobserve(el);
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    els.forEach(function (e) { io.observe(e); });
    /* Reveal anything already in view on load. iOS Safari can skip the observer's
       first callback for above-the-fold hero content until a scroll nudges it
       (mobile URL-bar viewport resize + negative rootMargin), leaving the hero
       headings invisible. Proactively show in-view elements, with a hard fallback. */
    function revealInView() {
      var vh = window.innerHeight || document.documentElement.clientHeight, n = 0;
      els.forEach(function (el) {
        if (el.classList.contains('in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) { show(el, n++); io.unobserve(el); }
      });
    }
    revealInView();
    window.addEventListener('load', revealInView);
    window.addEventListener('resize', revealInView);
    setTimeout(revealInView, 1000);
    /* Hard fallback: never leave content hidden if the observer and scroll hooks both fail. */
    setTimeout(function () { els.forEach(function (el) { el.classList.add('in'); }); }, 2600);
    /* Belt and braces: if the observer misses an element, the next scroll catches it. */
    var rvTick = false;
    window.addEventListener('scroll', function () {
      if (rvTick) return; rvTick = true;
      requestAnimationFrame(function () { revealInView(); rvTick = false; });
    }, { passive: true });
  }

  /* 3) parallax the header star layers on scroll */
  if (reduce) return;
  var ticking = false;
  function upd() {
    var vh = window.innerHeight;
    layers.forEach(function (layer) {
      var host = layer.parentElement, r = host.getBoundingClientRect();
      var mid = (r.top + r.height / 2) - vh / 2;
      layer.style.transform = 'translate3d(0,' + (mid * -0.35).toFixed(1) + 'px,0)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
  window.addEventListener('resize', upd);
  upd();
})();
